import React from 'react'
import Apps from '../../components/services/apps'

const AppsEn = () => {
  return <Apps lang='en' />
}
export default AppsEn